import {APP_INITIALIZER, NgModule, ErrorHandler} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormComponent } from './components/form/form.component';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import {EnvironmentService} from "@environments/environment.service";
import {SharedModule} from "@app/shared/shared.module";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {environment} from "@environments/environment";
import { NgxPayPalModule } from 'ngx-paypal';
import { CommonModule } from '@angular/common';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { YouTubePlayer } from '@angular/youtube-player';
import { GlobalErrorHandler } from "@app/shared/error-handler";
import { BsModalService } from 'ngx-bootstrap/modal';
import { RecaptchaModule, RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { NgxCurrencyDirective } from "ngx-currency";



@NgModule({
  declarations: [
    AppComponent,
    FormComponent
  ],
  imports: [
    LoggerModule.forRoot({
      level: environment.production ? NgxLoggerLevel.ERROR : NgxLoggerLevel.DEBUG,
    }),
    NgxPayPalModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    CommonModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    YouTubePlayer,
    RecaptchaModule,
    RecaptchaV3Module,
    NgxCurrencyDirective
  ],
  providers: [
    BsModalService,
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch()
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (envService: EnvironmentService, bsModalService: BsModalService) => {
        bsModalService.config.animated = true;
        bsModalService.config.backdrop = "static";
        bsModalService.config.focus = true;
        bsModalService.config.ignoreBackdropClick = true;
        bsModalService.config.keyboard = false;
        bsModalService.config.class = "modal-md";
        return () => Promise.all<any>([envService.loadEnvironment()]);
      },
      deps: [EnvironmentService, BsModalService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    // Sentry route tracing -- Sentry.TraceService instruments Angular Router
    // so navigations show up as transactions; the no-op factory APP_INITIALIZER
    // just ensures the service is constructed at bootstrap time.
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: () => (window as any).__runtimeConfig?.recaptchaV3SiteKey ?? '',
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
